/*
|--------------------------------------------------------------------------
| Comments
|--------------------------------------------------------------------------
*/
/**
 * Functionality for comments
 * @namespace
 */
__gh__webApp.comments.viafoura = {
	"init": function(){
		this.loadLibrary();
	},
	"loadLibrary": function(){
		  (function (v, s) {
		    v.type = 'text/javascript';
		    v.async = !0;
		    v.src = '//cdn.viafoura.net/vf.js';
		    s.parentNode.insertBefore(v, s);
		  }(document.createElement('script'), document.getElementsByTagName('script')[0]));
	},
	"reset":function(){
		// add third party callbacks here
		if (typeof viafoura !== 'undefined'){
			viafoura.poll();
		}
	}
};